import $ from 'jquery';
import { FireComponent } from '@component';
import { addScript } from '@utility';

export class Forms extends FireComponent {
  constructor(id) {
    super(id);
  }


  get hubspotForm() {
    const element = this.$component.find('[data-hubspot]');
    const target = `#${element.attr('id')}`;
    const portalId = element.attr('data-portal-id');
    const formId = element.attr('data-form-id');
		const formCSS = element.attr('data-form-css');
		const pageTitle = element.attr('data-page-title');


    return { target, portalId, formId, element, formCSS, pageTitle };
  }

	_addPageTitle() {
		const $form = this.$component.find('.hbspt-form'),
			$pageTitleField = $form.find('[name="source"]');

		$pageTitleField.val(this.hubspotForm.pageTitle);
	}

  /**
   * Initializes the Hubspot form
   */
  _initHubspotForm() {

    if (!this.hubspotForm.portalId || !this.hubspotForm.formId) {
      console.warn(`Skipped loading form missing Portal ID (${this.hubspotForm.portalId}) or Form ID (${this.hubspotForm.formId})`);
      return;
    }

    window.jQuery =
      window.jQuery ||
      (() => ({
        // these are all methods required by HubSpot
        change: () => {},
        trigger: () => {},
      }));

    addScript(
      {
        src: '//js.hsforms.net/forms/v2.js',
        type: 'text/javascript',
      },
      null,
      () => {
        hbspt.forms.create({
          portalId: this.hubspotForm.portalId,
          formId: this.hubspotForm.formId,
          target: this.hubspotForm.target,
					css: this.hubspotForm.formCSS,
          onFormReady: ($form, context) => {
						this._addPageTitle();
          },
        });
      }
    );
  }

  init() {
    if (!this.componentExists) return;
    this._initHubspotForm();
  }
}
